import { render } from "./ValueBody.vue?vue&type=template&id=41febcda&scoped=true"
import script from "./ValueBody.vue?vue&type=script&lang=js"
export * from "./ValueBody.vue?vue&type=script&lang=js"

import "./ValueBody.vue?vue&type=style&index=0&id=41febcda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41febcda"]])

export default __exports__